import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionButtonV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the action buttons for the form dialog based on form mode
 */
export const getFormActionButtons = (
  formMode: FormMode,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    onClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy, onClose } = handlers;

  if (formMode !== 'view') {
    return null;
  }

  // For view mode, show action buttons
  return (
    <>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} variant='destructive' />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} />
      <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={onClose} />
    </>
  );
};

/**
 * Get custom action buttons when hasInvoiceParams is true - hides "Đóng" button
 */
export const getFormActionButtonsWithInvoiceParams = (
  hasInvoiceParams: boolean,
  formMode: FormMode,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    onClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy } = handlers;
  const defaultActionButtons = getFormActionButtons(formMode, handlers);

  // When hasInvoiceParams is true, hide "Đóng" button
  if (hasInvoiceParams) {
    if (formMode !== 'view') {
      // For add/edit mode, only show "Lưu" button
      return (
        <>
          <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' variant='secondary' type='submit' />
        </>
      );
    } else {
      // For view mode, show all buttons except "Đóng"
      return (
        <>
          <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
          <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
          <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} />
          <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} />
        </>
      );
    }
  }

  // Default behavior: return default action buttons
  return defaultActionButtons;
};
